import { render, staticRenderFns } from "./LayoutDesignerHeader.vue?vue&type=template&id=3645ad9c"
import script from "./LayoutDesignerHeader.vue?vue&type=script&lang=js"
export * from "./LayoutDesignerHeader.vue?vue&type=script&lang=js"
import style0 from "./LayoutDesignerHeader.vue?vue&type=style&index=0&id=3645ad9c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3645ad9c')) {
      api.createRecord('3645ad9c', component.options)
    } else {
      api.reload('3645ad9c', component.options)
    }
    module.hot.accept("./LayoutDesignerHeader.vue?vue&type=template&id=3645ad9c", function () {
      api.rerender('3645ad9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/LayoutDesignerHeader.vue"
export default component.exports